import { useQuery } from "react-query";
import { getCategories } from "../APIs/marketplace";

const useAppCategory = () => {
  const { data: categories } = useQuery("get-categories", getCategories);

  return { categories };
};

export default useAppCategory;
